import classNames from 'classnames';
import React, { useState, useRef, useEffect } from 'react';
import styles from './style.module.scss';
import Heading from 'shared/components/common/heading/Heading';
import { logoSite, Printer } from 'assets';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useReactToPrint } from 'react-to-print';
import { useLocation } from 'react-router-dom';
import { formatPrice } from 'shared/utils/Helper';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';
import ModalImage from 'shared/components/common/custom_image_lightbox/ModalImage';
import ImageViewer from '../manage_task/ImageViewer';

export default function LayoutRl({ poDataProp, hidePrintButton }) {
    const componentRef = useRef(null);
    const location = useLocation();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });
    const sourceData = poDataProp || location?.state?.data || {};
    const [orderPO, setorderPO] = useState(sourceData?.order || []);
    const [dataPO, setdataPO] = useState(sourceData);
    const [address, setAddress] = useState('Shop # 54,Ground Floor,Century Tower,Main Link Road.');
    const [city, setCity] = useState('Lahore, Punjab');
    const [postal, setPostal] = useState('54000');
    const [email, setEmail] = useState('Techbizzksa@gmail.com');

    useEffect(() => {
        if (sourceData) {
            let clone = { ...sourceData };
            let list = sourceData?.order?.map((ii) => {
                return {
                    ...ii,
                    amount: (ii?.price || 0) * (ii?.quantity || 0)
                };
            });
            clone.order = list || [];
            setdataPO(clone);
        }
    }, [poDataProp, location?.state?.data]);
    console.log(dataPO,"dataPOdataPO");
    const formatPrice = (price) => {
        const num = Number(price);
        if (isNaN(num)) return 'Rs 0.00';
        return `Rs ${num.toFixed(2)}`;
    };

    const groupedBadges = React.useMemo(() => {
        if (!dataPO?.order || dataPO.order.length === 0) return [];
        const groups = {};
        dataPO.order.forEach((item) => {
            const b = item.badge || 1;
            if (!groups[b]) {
                groups[b] = {
                    badgeNum: b,
                    items: []
                };
            }
            groups[b].items.push(item);
        });
        const result = Object.values(groups).sort((a, b) => a.badgeNum - b.badgeNum);
        result.forEach(group => {
            const parentItems = [];
            const grandItemsMap = {};
            const otherItems = [];

            group.items.forEach(item => {
                const sku = item.sku ? item.sku.trim() : "";
                const isGrand = /^wt\d{6}[a-z][0-9]$/i.test(sku) || item.parentChildSku;
                if (isGrand) {
                    const parentKey = (item.parentChildSku || sku.slice(0, -1)).toLowerCase();
                    if (!grandItemsMap[parentKey]) grandItemsMap[parentKey] = [];
                    grandItemsMap[parentKey].push(item);
                } else if (sku && /^wt\d{6}[a-z]$/i.test(sku)) {
                    parentItems.push(item);
                } else {
                    otherItems.push(item);
                }
            });

            parentItems.sort((a, b) => (a.sku || "").localeCompare(b.sku || ""));

            const orderedItems = [];
            parentItems.forEach(parent => {
                orderedItems.push(parent);
                const parentKey = (parent.sku || "").toLowerCase();
                const grandChildren = grandItemsMap[parentKey] || [];
                grandChildren.sort((a, b) => (a.sku || "").localeCompare(b.sku || ""));
                orderedItems.push(...grandChildren);
                delete grandItemsMap[parentKey];
            });

            Object.values(grandItemsMap).forEach(remainingList => {
                orderedItems.push(...remainingList);
            });

            orderedItems.push(...otherItems);
            group.items = orderedItems;
        });
        return result;
    }, [dataPO?.order]);


    return (
        <div className={classNames(styles.mainpoLyout)} style={{ fontFamily: "'Outfit', 'Inter', sans-serif" }}>
            {!hidePrintButton && (
                <div className={classNames(styles.butoonprint)} style={{ zIndex: 10, right: '20px', top: '15px' }}>
                    <CustomButton 
                        Icon={Printer} 
                        submitHandle={() => handlePrint()} 
                        IconStyle={classNames('me-1', styles.IconStyle)} 
                        text={'Print'} 
                        containerStyle={classNames(styles.AddProduct)}
                        style={{ boxShadow: '0 4px 12px rgba(74, 134, 247, 0.2)' }}
                    />
                </div>
            )}
            <div 
                ref={componentRef} 
                className="bg-white"
                style={{
                    maxWidth: '1000px',
                    margin: '20px auto',
                    padding: '40px',
                    borderRadius: '16px',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.04)',
                    border: '1px solid rgba(0, 0, 0, 0.06)'
                }}
            >
                {/* Top Header Block */}
                <div className="d-flex justify-content-between align-items-start border-bottom pb-4 mb-4" style={{ gap: '20px' }}>
                    <div className="text-start">
                        <h4 className="d-flex align-items-center mb-2" style={{ fontWeight: '800', color: '#1e293b', fontSize: '26px' }}>
                            <img src={logoSite} alt="logo" style={{ marginRight: '12px', width: '40px', height: '40px' }} /> 
                            Wise Tech
                        </h4>
                        <p className="text-muted mb-0" style={{ fontSize: '13px', lineHeight: '1.6', maxWidth: '300px' }}>
                            Premium Wholesale & Inventory Solutions Platform
                        </p>
                    </div>

                    <div className="text-end d-flex flex-column gap-1" style={{ fontSize: '13px', color: '#475569', minWidth: '320px' }}>
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="fw-semibold text-secondary">Address:</span>
                            <span className="text-dark fw-medium">{address}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="fw-semibold text-secondary">City/State:</span>
                            <span className="text-dark fw-medium">{city}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="fw-semibold text-secondary">Postal Code:</span>
                            <span className="text-dark fw-medium">{postal}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="fw-semibold text-secondary">Email:</span>
                            <span className="text-dark fw-medium">{email}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-1 pt-1 border-top border-light">
                            <span className="fw-bold text-secondary">Warehouse:</span>
                            <span className="badge bg-primary bg-opacity-10 text-primary fw-bold px-2 py-1" style={{ borderRadius: '6px' }}>
                                {dataPO?.whareHouse?.warehouse?.code || '-'}
                            </span>
                        </div>
                    </div>
                </div>

                {/* Listing Details Header */}
                <div className="text-center mb-4">
                    <h2 className="mb-1" style={{ fontWeight: '800', color: '#0f172a', letterSpacing: '-0.5px' }}>ROUGH LISTING</h2>
                    <div style={{ width: '50px', height: '4px', background: '#3b82f6', margin: '0 auto', borderRadius: '2px' }}></div>
                </div>

                {/* Metadata Row (Bill to / Info Block) */}
                <div className="row g-4 mb-4 text-start">
                    <div className="col-md-6">
                        <div className="p-4 h-100" style={{ background: '#f8fafc', borderRadius: '12px', border: '1px solid #f1f5f9' }}>
                            <h6 className="text-uppercase tracking-wider text-secondary mb-3" style={{ fontSize: '11px', fontWeight: '700' }}>Bill to</h6>
                            <div className="d-flex flex-column gap-2" style={{ fontSize: '14px' }}>
                                <div className="d-flex">
                                    <span className="text-muted" style={{ width: '80px' }}>Name:</span>
                                    <span className="fw-semibold text-dark">{dataPO.supplier?.name || '-'}</span>
                                </div>
                                <div className="d-flex">
                                    <span className="text-muted" style={{ width: '80px' }}>Address:</span>
                                    <span className="text-dark">{dataPO.supplier?.address || '-'}</span>
                                </div>
                                <div className="d-flex">
                                    <span className="text-muted" style={{ width: '80px' }}>Phone:</span>
                                    <span className="text-dark">{dataPO.supplier?.phone || '-'}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="p-4 h-100" style={{ background: '#f8fafc', borderRadius: '12px', border: '1px solid #f1f5f9' }}>
                            <h6 className="text-uppercase tracking-wider text-secondary mb-3" style={{ fontSize: '11px', fontWeight: '700' }}>Listing Information</h6>
                            <div className="d-flex flex-column gap-2" style={{ fontSize: '14px' }}>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="text-muted">Rough Listing #:</span>
                                    <span className="fw-bold text-primary" style={{ fontSize: '15px' }}>{dataPO?.order_number}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="text-muted">Date:</span>
                                    <span className="text-dark fw-medium">{moment(dataPO?.created_at).format('DD, MMM YYYY')}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="text-muted">Submitted By (User):</span>
                                    <span className="text-dark fw-semibold">
                                        {dataPO?.submitted_by?.name || (typeof dataPO?.submitted_by === 'string' ? dataPO?.submitted_by : '-')}
                                    </span>
                                </div>
                                {dataPO?.approved_by && (
                                    <div className="d-flex justify-content-between align-items-center mt-1 pt-1 border-top border-light">
                                        <span className="text-muted fw-semibold">Approved By (Admin):</span>
                                        <span className="badge bg-success bg-opacity-10 text-success fw-bold px-2 py-1" style={{ borderRadius: '6px' }}>
                                            {dataPO?.approved_by?.name || (typeof dataPO?.approved_by === 'string' ? dataPO?.approved_by : '-')}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Grouped Batches */}
                {groupedBadges.map((badgeGroup) => (
                    <div key={badgeGroup.badgeNum} className="mb-4 text-start">
                        <div className="d-flex align-items-center mb-2 px-1">
                            <h5 className="mb-0 text-dark fw-bold" style={{ fontSize: '15px' }}>
                                Batch {badgeGroup.badgeNum}
                            </h5>
                            <span className="text-muted ms-2" style={{ fontSize: '12px' }}>
                                ({badgeGroup.items.length} item{badgeGroup.items.length !== 1 ? 's' : ''} in this batch)
                            </span>
                        </div>
                        <div style={{ borderRadius: '12px', border: '1px solid #e2e8f0', overflow: 'hidden', marginBottom: '16px' }}>
                            <table className="table mb-0 align-middle" style={{ borderCollapse: 'collapse', width: '100%' }}>
                                <thead style={{ background: '#f8fafc' }}>
                                    <tr style={{ borderBottom: '1px solid #cbd5e1' }}>
                                        <th style={{ width: '40%', padding: '12px 15px', color: '#475569', fontSize: '11px', fontWeight: '700' }} className="text-start text-uppercase">Description</th>
                                        <th style={{ width: '18%', padding: '12px 15px', color: '#475569', fontSize: '11px', fontWeight: '700' }} className="text-center text-uppercase">SKU</th>
                                        <th style={{ width: '14%', padding: '12px 15px', color: '#475569', fontSize: '11px', fontWeight: '700' }} className="text-center text-uppercase">Status</th>
                                        <th style={{ width: '8%', padding: '12px 15px', color: '#475569', fontSize: '11px', fontWeight: '700' }} className="text-center text-uppercase">Qty</th>
                                        <th style={{ width: '10%', padding: '12px 15px', color: '#475569', fontSize: '11px', fontWeight: '700' }} className="text-center text-uppercase">Rate</th>
                                        <th style={{ width: '10%', padding: '12px 15px', color: '#475569', fontSize: '11px', fontWeight: '700' }} className="text-end text-uppercase">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {badgeGroup.items.map((Item, inx) => (
                                        <tr key={inx} style={{ borderBottom: '1px solid #e2e8f0' }}>
                                            <td className="text-start" style={{ padding: '12px 15px' }}>
                                                <div className="d-flex flex-column gap-1">
                                                    <span style={{ fontSize: '11px', color: '#64748b', fontWeight: '600' }}>
                                                        {Item.brand?.name || '-'} • {Item.compatiableBrand?.name || '-'}
                                                    </span>
                                                    <span style={{ fontSize: '13px', color: '#0f172a', fontWeight: '700' }}>
                                                        {Item.product?.name || '-'}
                                                    </span>
                                                    <span style={{ fontSize: '10px', color: '#94a3b8' }}>
                                                        Category: {Item.product_category?.name || '-'} • Sub: {Item.sub_category?.name || '-'} • Color: {Item.color || '-'}
                                                    </span>
                                                </div>
                                            </td>
                                            <td className="text-center" style={{ padding: '12px 15px', whiteSpace: 'nowrap' }}>
                                                {Item?.sku && /^wt\d{6}[a-z][0-9]$/i.test(Item.sku) && (
                                                    <span style={{ fontSize: '11px', color: '#0284c7', marginRight: '4px', fontWeight: 'bold' }}>↳</span>
                                                )}
                                                <code style={{ fontSize: '12px', background: Item?.sku && /^wt\d{6}[a-z][0-9]$/i.test(Item.sku) ? '#f0fdf4' : '#f8fafc', padding: '3px 6px', borderRadius: '4px', border: Item?.sku && /^wt\d{6}[a-z][0-9]$/i.test(Item.sku) ? '1px solid #86efac' : '1px solid #e2e8f0', color: Item?.sku && /^wt\d{6}[a-z][0-9]$/i.test(Item.sku) ? '#166534' : '#0f172a', fontWeight: '600' }}>
                                                    {Item?.sku || 'N/A'}
                                                </code>
                                            </td>
                                            <td className="text-center" style={{ padding: '12px 15px', whiteSpace: 'nowrap' }}>
                                                {Item.status === 'approved' ? (
                                                    <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-2 py-1" style={{ fontSize: '10px', borderRadius: '6px', fontWeight: '700' }}>
                                                        Approved
                                                    </span>
                                                ) : Item.status === 'declined' ? (
                                                    <span className="badge bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25 px-2 py-1" style={{ fontSize: '10px', borderRadius: '6px', fontWeight: '700' }}>
                                                        Declined
                                                    </span>
                                                ) : (
                                                    <span className="badge bg-warning bg-opacity-10 text-warning border border-warning border-opacity-25 px-2 py-1" style={{ fontSize: '10px', borderRadius: '6px', fontWeight: '700', color: '#856404' }}>
                                                        Pending
                                                    </span>
                                                )}
                                            </td>
                                            <td className="text-center" style={{ padding: '12px 15px', color: '#334155', fontWeight: '600', fontSize: '13px' }}>{Item.quantity}</td>
                                            <td className="text-center" style={{ padding: '12px 15px', color: '#334155', fontSize: '13px' }}>{formatPrice(Item.price)}</td>
                                            <td className="text-end" style={{ padding: '12px 15px', color: '#0f172a', fontWeight: '700', fontSize: '13px' }}>{formatPrice(Item.amount)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}

                {/* Subtotal & Total Row */}
                <div className="d-flex justify-content-end text-end mt-4">
                    <div className="p-3" style={{ background: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0', minWidth: '280px' }}>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="text-muted fw-medium" style={{ fontSize: '14px' }}>Gross Total:</span>
                            <span className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                                {formatPrice(
                                    dataPO?.order?.map((ii) => ii.amount).reduce((acc, curr) => acc + curr, 0)
                                )}
                            </span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center pt-2 border-top border-light">
                            <span className="text-secondary fw-bold" style={{ fontSize: '15px' }}>Grand Total:</span>
                            <span className="text-primary fw-bold" style={{ fontSize: '18px' }}>
                                {formatPrice(
                                    dataPO?.order?.map((ii) => ii.amount).reduce((acc, curr) => acc + curr, 0)
                                )}
                            </span>
                        </div>
                    </div>
                </div>

                {/* Footer Brand info */}
                <div className="d-flex justify-content-between align-items-center border-top pt-4 mt-5" style={{ fontSize: '12px', color: '#94a3b8' }}>
                    <div className="text-start">
                        <a href="/" className="text-decoration-none fw-bold" style={{ color: '#3b82f6' }}>wisetech.com</a>
                    </div>
                    <div>
                        <img src={logoSite} alt="logo" style={{ maxWidth: '60px' }} />
                    </div>
                </div>
            </div>
        </div>
    );
}
